export default __webpack_public_path__ + "static/cryptostamp-538d77536956a44c294791fda5927717.jpg";